import { Core as WalletConnectCore } from "./core";

export * from "./constants";
export * from "./controllers";

export const Core = WalletConnectCore;
export default WalletConnectCore;
